angular.module('aprima-legacy-common').factory('$qHelpers', ['$q', '_', '$timeout', function ($q, _, $timeout) {
    'use strict';

    return {
        whenFirstSuccess: whenFirstSuccess,
        timeout: timeout,
        delay: delay,
        abortablePromise: abortablePromise,
        isPromise: isPromise,
        abortPromises: abortPromises,
        abortPromise: abortPromise
    };

    function whenFirstSuccess(promises) {
        //Will resolve to the value of the first successful promise in order.
        //Ignores rejected promises unless ALL were rejected, then the returned promise will be rejected.
        
        var deferred = $q.defer();
        var results = [];
        var resolved = false;
        //Use reference instead of value for comparison.
        var rejectionFlagValue = {};

        function tryResolveToFirstSuccess() {
            var index = -1;
            var length = results ? results.length : 0;

            if (!results || resolved) {
                return false;
            }

            while (++index < length) {
                var result = results[index];

                if (result === undefined) {
                    return false;
                }

                if (result !== rejectionFlagValue) {
                    resolved = true;
                    deferred.resolve(result);
                    results = null;
                    return false;
                }
            }

            deferred.reject('Could not resolve first successful promise. All promises were rejected.');
        }

        _.forEach(promises, function (promise, index) {
            results[index] = undefined;

            promise.then(function (result) {
                if (!resolved) {
                    results[index] = result;
                    tryResolveToFirstSuccess();
                }
            }, function () {
                if (!resolved) {
                    results[index] = rejectionFlagValue;
                    tryResolveToFirstSuccess();
                }
            });

        });

        return deferred.promise;
    }

    function timeout(promise, time) {
        var deferred = $q.defer(),
            timeoutPromise = $timeout(function() {
                deferred.reject('Promise took too long to resolve and was rejected.');
            }, time);

        promise
            .then(function (result) {
                deferred.resolve(result);
            })
            .catch(function (err) {
                deferred.reject(err);
            })
            .finally(function() {
                $timeout.cancel(timeoutPromise);
            });

        return deferred.promise;
    }

    function delay(promise, time) {
        var deferred = $q.defer();

        $timeout(function() {
            promise
                .then(function (result) {
                    deferred.resolve(result);
                })
                .catch(function (err) {
                    deferred.reject(err);
                });
        }, time);

        return deferred.promise;
    }

    function abortablePromise(promise, previousPromises, shouldRejectOnAbort) {
        var deferred = $q.defer();
        shouldRejectOnAbort = angular.isFunction(shouldRejectOnAbort) ? _.once(shouldRejectOnAbort) : function(){ return true; };

        abortPromises(previousPromises);

        promise
            .then(function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });

        var error = {isAborted: true, msg: 'Aborted'};
        deferred.promise.abort = function abort() {
            var shouldAbort = !!shouldRejectOnAbort(error);
            if(shouldAbort) {
                deferred.reject(error);
            }
            return shouldAbort;
        };

        replaceChainFnsWithAbortableFns(deferred.promise, 'then');
        replaceChainFnsWithAbortableFns(deferred.promise, 'catch');
        replaceChainFnsWithAbortableFns(deferred.promise, 'finally');

        return deferred.promise;
    }
    
    function abortPromises(promises) {
        if(!_.isArray(promises)) {
            abortPromise(promises);
            return;
        }

        _.forEach(promises, function (promise) {
            abortPromise(promise);
        });
    }

    function abortPromise(promise) {
        if(promise && promise.abort){
            promise.abort();
        }
    }
    
    function replaceChainFnsWithAbortableFns(promise, chainFnKey) {
        var wrappedKey = '_' + chainFnKey;
        var wrappedFn = promise[wrappedKey] = promise[wrappedKey] || promise[chainFnKey] || angular.noop;

        promise[chainFnKey] = function() {
            var chained = wrappedFn.apply(promise, arguments);
            if(_.isFunction(chained.abort)) {
                return chained;
            }
            
            var newPromise = abortablePromise(chained, null, function() {
                return promise.abort();
            });
            return newPromise;
        };
    }

    function isPromise(value) {
        return !!(value && angular.isFunction(value.then) && angular.isFunction(value.catch) && angular.isFunction(value.finally));
    }
}]);